export default "__VITE_ASSET__DCjPrAIE__"